import { isEmpty } from 'underscore';
import unescapedText from 'I18n/utils/unescapedText';
import { createSearchRegExp, hasSearchMatch } from 'ContentComponents/cmv2/utils/generic';
import { DEFAULT_GOOGLE_FONT_VARIANT_FALLBACK_ORDER } from 'ContentUtils/constants/Fonts';
export const combineFonts = (fontOptions, hasMore = false, input = '') => {
  const {
    googleFontOptions,
    systemFonts
  } = fontOptions;
  const searchRegExp = createSearchRegExp(input);
  const systemFontOptions = systemFonts.filter(font => {
    return hasSearchMatch(searchRegExp, font.text);
  });
  let systemIndex = 0;
  let fontList = [];
  while (!isEmpty(googleFontOptions) && systemFontOptions[systemIndex] && systemFontOptions[systemIndex].text < googleFontOptions[0].text) {
    fontList.push(systemFontOptions[systemIndex]);
    systemIndex++;
  }
  googleFontOptions.reduce((combinedFontList, fontOption, index) => {
    const systemFont = systemFontOptions[systemIndex];
    const previousFont = googleFontOptions[index - 1];
    if (systemFont && systemFont.text < fontOption.text) {
      if (previousFont && systemFont.text > previousFont.text) {
        combinedFontList.push(systemFont);
        systemIndex++;
      }
      if (!previousFont) {
        combinedFontList.push(systemFont);
        systemIndex++;
      }
    }
    combinedFontList.push(fontOption);
    return combinedFontList;
  }, fontList);
  if (!hasMore && systemFontOptions.length) {
    fontList = fontList.concat(systemFontOptions.slice(systemIndex));
  }
  return fontList;
};
const i18nKey = key => `ContentComponents.cmv2.fields.font.${key}`;
export const formatVariant = variant => {
  const weight = parseInt(variant, 10) || 400;
  let variantText = unescapedText(i18nKey(`weights.${weight}`));
  if (variant.includes('italic')) {
    variantText = unescapedText(i18nKey('weights.italic'), {
      weight: variantText
    });
  }
  return variantText;
};
export const getVariantStyles = variant => {
  const styles = {
    fontWeight: parseInt(variant, 10) || 400
  };
  if (variant.includes('italic')) styles.fontStyle = 'italic';
  return styles;
};
export const getDefaultVariant = googleFont => {
  const variantsMap = googleFont.variants ? googleFont.variants.reduce((map, variant) => {
    map[variant] = variant;
    return map;
  }, {}) : {};
  for (const variant of DEFAULT_GOOGLE_FONT_VARIANT_FALLBACK_ORDER) {
    if (variantsMap[variant]) return variant;
  }
  return googleFont.variants ? googleFont.variants[0] : '';
};
const fontsCache = {};
const variantsCache = {};
export const loadFontStylesheet = (family, variants) => {
  if (!family) {
    return;
  }
  const googleFontUrl = `https://fonts.googleapis.com/css2?family=${family.replace(/\s/g, '+')}`;
  let weights = '';
  if (variants && !variantsCache[family]) {
    variantsCache[family] = family;
    weights = `:wght@${variants.filter(variant => !variant.includes('italic')).map(variant => parseInt(variant, 10) || 400).join(';')}`;
  }
  if (fontsCache[family]) {
    // The variants tend to load later, so this adds in the weights after
    // the font stylesheet was already added
    if (weights) {
      const linkEl = document.querySelector(`link[href^="${googleFontUrl}"]`);
      linkEl.setAttribute('href', `${googleFontUrl}${weights}`);
    }
    return;
  }
  fontsCache[family] = family;
  const linkEl = document.createElement('link');
  linkEl.setAttribute('href', `${googleFontUrl}${weights}`);
  linkEl.setAttribute('rel', 'stylesheet');
  document.getElementsByTagName('head')[0].appendChild(linkEl);
};